export default __webpack_public_path__ + "static/media/right-heading.png?.6307b155";